import React, { Suspense } from "react";
import { Navigate, useParams } from "react-router-dom";

import ComponentLoader from "@performyard/py-components/src/components/atoms/ComponentLoader";

import { useRbacObjectPermissions } from "../../../api/hooks/defs/rbac";
import { useFeatureFlagQuery } from "../../../hooks/useFeatureFlag";

import ErrorPage from "../../Error";

const LazyAddFormsPage = React.lazy(() => import("./AddFormsPage"));

const CenteredLoader = () => (
	<div className="flex h-[calc(100vh-104px)] w-full items-center justify-center">
		<ComponentLoader />
	</div>
);

const AddFormsGate = () => {
	const { cycleId = "" } = useParams();
	const { value: optionsRefreshEnabled, query: flagQuery } = useFeatureFlagQuery(
		"ff-temp-is-review-cycle-options-refresh-enabled",
		false
	);
	const { data: permissions } = useRbacObjectPermissions("review", cycleId);

	if (!flagQuery.isFetched || permissions === undefined) {
		return <CenteredLoader />;
	}

	// Render the 403 page instead of redirecting: the details page's route loader
	// also 403s for these users, which surfaces as the application-error screen
	if (!permissions.includes("review_cycle:addFormsInCycle")) {
		return <ErrorPage code={403} />;
	}

	if (!optionsRefreshEnabled) {
		return <Navigate to={`/review-cycle/${cycleId}/`} replace />;
	}

	return (
		<Suspense fallback={<CenteredLoader />}>
			<LazyAddFormsPage cycleId={cycleId} />
		</Suspense>
	);
};

export default AddFormsGate;
